import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, scroll the window to the top.
 * Skips scroll-reset if the URL has a hash (#section) so anchor links still work.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let anchor links handle themselves
    // Use instant scroll (not smooth) to feel like a real page load
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
